var ShutterDraw = (function() {

	var $container = $("#shutter-draw"),
		// Define jQuery objects for creation of shutter elements. These will be cloned as needed
		shutterElementProto = {
			$panel: $("<div class=\"shutter-draw-panel\" />"),
			$panelGrouper: $("<div class=\"shutter-draw-group\" />"),
			$panelCenter: $("<div class=\"shutter-draw-panel-center\" />"),
			$panelInner: $("<div class=\"shutter-draw-panel-inner\" />"),
			$panelLouvreContainer: $("<div class=\"shutter-draw-panel-louvre-container\" />"),
			$panelFrame: $("<div class=\"shutter-draw-panel-frame\" />"),
			$louvre: $("<div class=\"shutter-draw-louvre\" />"),
			$panelSolid: $("<div class=\"shutter-draw-panel-solid\" />"),
			$tiltrod: $("<div class=\"shutter-draw-tiltrod\" />"),
			$tiltrodTop: $("<div class=\"shutter-draw-tiltrod-top\" />"),
			$tiltrodBottom: $("<div class=\"shutter-draw-tiltrod-bottom\" />"),
			$tiltrodMousehole: $("<div class=\"shutter-draw-tiltrod-mousehole\" />"),
			$hinge: $("<div class=\"shutter-draw-hinge\" />"),
			$cord: $("<div class=\"shutter-draw-cord\" />")
		},
		// Create an object to store the form data in
		shutterData = {},
		// Define a max pixel height/width. This is not max mm height/width but the largest we want the shutter on 
		// the page itself to be
		maxHeight = 500,
		maxWidth = $container.parent().width(),
		// Set some global mm sizing
		mmStandardFrameHeight = 65,
		mmStandardFrameWidth = 65,
		mmStandardTiltrodWidth = 26,
		mmHingeWidth = 20,
		mmHingeHeight = 60,
		// Handle form changes, firing off the image data
		handleShutterFormChanged = function(data) {
			if($("#shutter-design-form").find(".has-error").length == 0) {
				shutterData = data;
				shutterFormChanged();
			}
		},
		// Function that draws the shutter
		shutterFormChanged = function() {
			// Gather some form/sizing data
			var isBlind = shutterData['blind']['is_blind'],
				mmWidth = parseInt(shutterData['dimensions']['width']) + (mmStandardFrameWidth * 2),
				mmHeight = parseInt(shutterData['dimensions']['height']) + (mmStandardFrameHeight * 2),
				paint = shutterData['colours-finishes']['paint'],
				stain = shutterData['colours-finishes']['stain'],
				$cssElement = $("<style type=\"text/css\" id=\"shutter-css\"></style>");


			if(!isBlind) {
				var range = shutterData['shutter']['range'],
					style = shutterData['shutter']['style'],
					panelConfiguration = shutterData['panels-louvres']['panel-configuration'],
					hinge = shutterData['colours-finishes']['hinge'],
					knob = shutterData['colours-finishes']['knob'];
			}
			// Add class is the shutter is actually a blind
			if(isBlind) {
				$container.addClass("shutter-is-blind");
			} else {
				// Add classes to the container to represent the current style and range
				$container.addClass("shutter-range-" + range + " shutter-style-" + style);
			}
			// Clear any existing dyanmically added CSS
			$("#shutter-css").remove();
			// Add a new CSS element ready to be added to
			$cssElement.insertAfter($container);
			// Remove any lightness state classes from the container
			$container.removeClass('shutter-draw-shade-light shutter-draw-shade-medium shutter-draw-shade-dark')
			// If a paint or stain is selected..
			if(paint || stain) {
				// .. start generating CSS to add the background to the shutter elements
				var $backgroundTemplate = $('#template-background-style'),
					backgroundTemplate = Handlebars.compile($backgroundTemplate.html()),
					backgoundCss;
				if(paint) {
					backgroundCss = backgroundTemplate({ "value": "background-color:" + window.shutterData.paints[paint].colour });
					$container.addClass("shutter-draw-shade-" + window.shutterData.paints[paint].shade);
				} else if(stain) {
					backgroundCss = backgroundTemplate({ "value": "background-image: url(\"" + window.shutterData.stains[stain].texture + "\")" });
					$container.addClass("shutter-draw-shade-" + window.shutterData.stains[stain].shade);
				}
				$cssElement.append(backgroundCss);
				$container.removeClass('shutter-no-colour');
			} else {
				// A paint or stain was not selected so add defaults
				$container.addClass('shutter-no-colour');
				$container.addClass("shutter-draw-shade-medium");
			}
			if(!isBlind) {
				// If hinge colour has been selected..
				if(hinge) {
					// .. add CSS to set the colour on the hinge elements
					var $hingeTemplate = $('#template-hinge-style'),
						hingeTemplate = Handlebars.compile($hingeTemplate.html()),
						hingeCss = hingeTemplate({ "value": "background-color:" + window.shutterData.hardwareMaterials[hinge].colour });
					$cssElement.append(hingeCss);
				}
				// If knob colour has been selected..
				if(knob) {
					// .. add CSS to set the colour on the knob elements
					var $hingeTemplate = $('#template-knob-style'),
						knobTemplate = Handlebars.compile($knobTemplate.html()),
						knobCss = knobTemplate({ "value": "background-color:" + window.shutterData.hardwareMaterials[knob].colour });
					$cssElement.append(knobCss);
				}
			}
			
			var containerWidth = $container.width(),
				scale = Math.min( maxWidth / mmWidth, maxHeight / mmHeight ).toFixed(2),
				width = Math.floor(mmWidth * scale),
				height = Math.floor(mmHeight * scale),
				mmLouvreHeight = 64,
				frameHeight = Math.floor(mmStandardFrameHeight * scale),
				louvreHeight = Math.ceil(mmLouvreHeight * scale),
				verticalPanelCount = horizontalPanelCount = 1;

			if(!isBlind) {
				var mmLouvreHeight = parseInt(shutterData['panels-louvres']['louvre-size']),
					horizontalPanelCount = shutterData['panels-louvres']['number-of-panels'] || 3,
					midRail = shutterData['panels-louvres']['mid-rail'],
					midRailIsActuallyDivider = shutterData['panels-louvres']['mid-rail-is-actually-divider'],
					verticalPanelCount = (midRailIsActuallyDivider && midRail) ? 2 : 1,
					mmMidRailHeight = parseInt(shutterData['panels-louvres']['mid-rail-height']) || 0,
					midRailHeight = mmMidRailHeight * scale,
					frameWidth = Math.floor(mmStandardFrameWidth * scale),
					hingeWidth = Math.floor(mmHingeWidth * scale),
					hingeHeight = Math.floor(mmHingeHeight * scale),
					hingeLeft = true,
					hingeRight = true;
			}

			// Establish the value of some hinge related variables based on the provided configuration
			if(panelConfiguration) {
				// If the the first letter of the panel config string is L, there is a hinge on the left hand side of the shutter
				if(panelConfiguration.substr(0,1) == 'L') {
					hingeLeft = true;
				} else {
					hingeLeft = false;
				}
				// If the the first letter of the panel config string is R, there is a hinge on the right hand side of the shutter
				if(panelConfiguration.substr(-1) == 'R') {
					hingeRight = true;
				} else {
					hingeRight = false;
				}
			}
			// Ensure the height will fit louvres well. We do this mainly by removing the remainder of the height / louvre-height
			height = height - (((height + (midRail ? frameHeight : 0) ) - (frameHeight * 2)) % louvreHeight) + (louvreHeight / 3);
			// Ensure the height is even
			if(height % 2 != 0) {
				height = height - 1;
			}
			// Clear the container
			$container.html("");
			$container.width(width);
			// There may be more than one vertical panel, create horizontal panels and louvres for each
			_l.times(verticalPanelCount, function(n) {
				// Create a new panel container
				var $newHorizontalPanelGroup = shutterElementProto.$panelGrouper.clone();
				$newHorizontalPanelGroup.appendTo($container);
				// Do some height calculations
				if(verticalPanelCount > 1 && n == 0) {
					if(!midRailHeight) {
						height = height / 2;
					} else {
						height = height - midRailHeight;
					}
				} else if(verticalPanelCount > 1 && n == 1 && midRailHeight) {
					height = midRailHeight;
				}
				// Create frames and panels across the container, create as many horizontal panels as are required
				_l.times(horizontalPanelCount, function(n) {
					var $newPanel = shutterElementProto.$panel.clone(),
						$newPanelFrameLeft = shutterElementProto.$panelFrame.clone(),
						$newPanelFrameRight = shutterElementProto.$panelFrame.clone(),
						$newPanelFrameTop = shutterElementProto.$panelFrame.clone(),
						$newPanelFrameBottom = shutterElementProto.$panelFrame.clone(),
						$newPanelCenter = shutterElementProto.$panelCenter.clone(),
						$newPanelInner = shutterElementProto.$panelInner.clone(),
						innerCount = (midRail && !midRailIsActuallyDivider) ? 2 : 1;

					$newHorizontalPanelGroup.append($newPanel);

					var newPanelHeight = height,
						newTotalFrameHeights = (frameHeight * 2);
					newPanelHeight = newPanelHeight + newTotalFrameHeights;
					$newPanel.addClass("shutter-draw-panel-" + horizontalPanelCount + "-panels").css('height', newPanelHeight);

					if(!isBlind) {
						if(!panelConfiguration) {
							panelConfiguration = "LLR";
						}
						$newPanel.addClass("shutter-draw-panel-configuration-" + panelConfiguration.substring(n,n+1).toLowerCase());
						$newPanelFrameLeft.appendTo($newPanel).addClass('shutter-draw-panel-frame-left').css('width', frameWidth);
			 			$newPanelFrameRight.appendTo($newPanel).addClass('shutter-draw-panel-frame-right').css('width', frameWidth);
		 			}
		 			$newPanelCenter.appendTo($newPanel).css({ 'left': frameWidth, 'right': frameWidth });
					$newPanelFrameTop.appendTo($newPanelCenter).addClass('shutter-draw-panel-frame-top').css({ 'height': frameHeight });
					
					$newPanelInner.appendTo($newPanelCenter)

					if(!isBlind) {
						$newPanelFrameBottom.appendTo($newPanelCenter).addClass('shutter-draw-panel-frame-bottom').css({ 'height': frameHeight });
						$newPanelInner.css({ 'margin-top': frameHeight, 'margin-bottom': frameHeight  });
					} else {
						$newPanelInner.css({ 'margin-top': frameHeight });
					}

					_l.times(innerCount, function(n) {
						var panelContainerN = n + 1,
							$newPanelLouvreContainer = shutterElementProto.$panelLouvreContainer.clone(),
							newPanelInnerHeight = $newPanelInner.height(),
							lastInnerPanel = (panelContainerN == innerCount),
							newPanelContainerHeight;

						$newPanelLouvreContainer.appendTo($newPanelInner);

						if(innerCount > 1) {
							if(midRailHeight && !lastInnerPanel) {
								newPanelContainerHeight = newPanelInnerHeight - midRailHeight - frameHeight;
							} else if(midRailHeight && lastInnerPanel) {
								newPanelContainerHeight = midRailHeight - frameHeight;
							} else {
								newPanelContainerHeight = (newPanelInnerHeight / innerCount) - (frameHeight / innerCount);
							}
							if(midRailHeight) {
								newPanelContainerHeight = newPanelContainerHeight + (frameHeight / innerCount)
							}
						} else {
							newPanelContainerHeight = newPanelInnerHeight;
						}

						$newPanelLouvreContainer.css('height', newPanelContainerHeight);

						if(!lastInnerPanel && innerCount > 1) {
							var $newPanelMidFrame = shutterElementProto.$panelFrame.clone();
							$newPanelMidFrame.appendTo($newPanelInner).addClass('shutter-draw-panel-frame-mid').height(frameHeight);
						}

						if(range !== 'solid-shaker' && range !== 'solid-raised') {
							// Not a solid range
							var fitNLouvres = Math.floor(newPanelContainerHeight / louvreHeight);

							_l.times(fitNLouvres, function(i) {
								var $newLouvre = shutterElementProto.$louvre.clone();
								$newLouvre.appendTo($newPanelLouvreContainer);
								$newLouvre.css({ 
									'height': louvreHeight,
									'z-index': 1000 - i
								}).addClass('shutter-draw-louvre-' + (i+1));
								if(isBlind) {
									var $newCordLeft = shutterElementProto.$cord.clone(),
										$newCordRight = shutterElementProto.$cord.clone();
									$newCordLeft.appendTo($newLouvre);
									$newCordRight.appendTo($newLouvre);
									$newCordLeft.addClass('shutter-draw-cord-left');
									$newCordRight.addClass('shutter-draw-cord-right');
								}
							});

							if(!isBlind) {
								var tiltrodPosition = shutterData['panels-louvres']['tiltrod-position'];
								if(tiltrodPosition == 'central' || tiltrodPosition == 'offset') {
									var $newTiltrod = shutterElementProto.$tiltrod.clone(),
										$newTiltrodTop = shutterElementProto.$tiltrodTop.clone(),
										$newTiltrodBottom = shutterElementProto.$tiltrodBottom.clone(),
										$newTiltrodMouseholeTop = shutterElementProto.$tiltrodMousehole.clone(),
										tiltrodWidth = mmStandardTiltrodWidth * scale;
									$newTiltrod.appendTo($newPanelInner).addClass('shutter-draw-tiltrod-' + tiltrodPosition).width(tiltrodWidth);
									$newTiltrodTop.appendTo($newTiltrod).css({
										"height": tiltrodWidth,
										"width": tiltrodWidth
									});
									$newTiltrodBottom.appendTo($newTiltrod).css({
										"height": tiltrodWidth,
										"width": tiltrodWidth
									});
									$newTiltrodMouseholeTop.appendTo($newPanelFrameTop).css({
										"height": tiltrodWidth,
										"width": tiltrodWidth
									}).addClass('shutter-draw-tiltrod-mousehole-top shutter-draw-tiltrod-mousehole-' + tiltrodPosition);
								}
							}
						} else {
							// Is a solid range: solid shaker or raised
							$container.addClass('shutter-solid');
							var $newPanelSolid = shutterElementProto.$panelSolid.clone();
							$newPanelSolid.appendTo($newPanelLouvreContainer);
						}
					});
				});
				if(!isBlind) {
					// Add CSS for solid ranges if the current range is solid
					if(range === 'solid-shaker' || range === 'solid-raised') {
						var $solidBorderTemplate = $('#template-solid-panel-style'),
							solidBorderTemplate = Handlebars.compile($solidBorderTemplate.html()),
							solidBorderTemplateCss = solidBorderTemplate({ "value": Math.floor(20 * scale) });
						$cssElement.append(solidBorderTemplateCss);
					}
					// Create hinge objects
					var $topLeftHinge = shutterElementProto.$hinge.clone(),
						$bottomLeftHinge = shutterElementProto.$hinge.clone(),
						$topRightHinge = shutterElementProto.$hinge.clone(),
						$bottomRightHinge = shutterElementProto.$hinge.clone();
					// Add hinges to the shutter if they are needed
					if(hingeLeft) {
						$topLeftHinge.appendTo($newHorizontalPanelGroup).addClass('shutter-draw-hinge-tl').css({ 'width': hingeWidth, 'height': hingeHeight });
						$bottomLeftHinge.appendTo($newHorizontalPanelGroup).addClass('shutter-draw-hinge-bl').css({ 'width': hingeWidth, 'height': hingeHeight });
					}
					if(hingeRight) {
						$topRightHinge.appendTo($newHorizontalPanelGroup).addClass('shutter-draw-hinge-tr').css({ 'width': hingeWidth, 'height': hingeHeight });
						$bottomRightHinge.appendTo($newHorizontalPanelGroup).addClass('shutter-draw-hinge-br').css({ 'width': hingeWidth, 'height': hingeHeight });
					}
				}
			});

		}

	return {
		init: function() {
			this.initEvents();
		},

		initEvents: function() {
			Shutter.addCallback('change', _l.throttle(handleShutterFormChanged, 100) );

			$container.on('click', function() {
				$(this).toggleClass('shutter-closed');
			})
		}
	}

})();
